<header
  class="login-hdr"
  [ngStyle]="{ 'border-color': themeService.getThemeColor(themeService.ThemeItemEnum.header) }"
>
  <img *ngIf="!!showCFEPLogo" class="cfep-logo" src="assets/images/CFEP-logo.png" alt="cfep-logo" />
  <img *ngIf="!!cobrandedLogo" class="cfep-logo" [src]="cobrandedLogo" alt="cobranded-logo" />
</header>
